import { Box, Divider } from "@material-ui/core";
import PropTypes from "prop-types";
import Row from "./Row";
import { formatCents } from "./utils";

export default function ShipmentTotals({ shipment }) {
  const ccy = shipment?.currency || "usd";

  return (
    <Box mt={1}>
      <Row
        label="Subtotal"
        value={formatCents(shipment.subtotalWithBump, ccy)}
      />

      {shipment.serviceFee > 0 && (
        <Row
          label="Service Fee"
          value={formatCents(shipment.serviceFee, ccy)}
        />
      )}

      {shipment.promoCodeDiscount !== 0 &&
        shipment.promoCodeAppliesTo === "subtotal" && (
          <Row
            label="Promo Code"
            value={formatCents(shipment.promoCodeDiscount, ccy)}
          />
        )}

      {shipment.tax > 0 && (
        <Row label="Tax" value={formatCents(shipment.tax, ccy)} />
      )}

      <Row
        label="Shipping"
        value={
          shipment.shippingCost > 0
            ? formatCents(shipment.shippingCost, ccy)
            : "Free"
        }
      />

      {shipment.promoCodeDiscount !== 0 &&
        shipment.promoCodeAppliesTo !== "subtotal" && (
          <Row
            label="Promo Code"
            value={formatCents(shipment.promoCodeDiscount, ccy)}
          />
        )}

      <Box my={1}>
        <Divider />
      </Box>

      <Row label="Total" value={formatCents(shipment.total, ccy)} bold />
    </Box>
  );
}

ShipmentTotals.propTypes = {
  shipment: PropTypes.shape({
    subtotalWithBump: PropTypes.number.isRequired,
    productBump: PropTypes.number,
    promoCodeDiscount: PropTypes.number,
    promoCodeAppliesTo: PropTypes.string,
    serviceFee: PropTypes.number,
    shippingCost: PropTypes.number,
    shippingRateAdjustment: PropTypes.number,
    tax: PropTypes.number,
    total: PropTypes.number.isRequired,
    currency: PropTypes.string,
  }).isRequired,
  currency: PropTypes.string.isRequired,
};
